/* eslint-disable */
import React from "react";
import { Link } from "react-router-dom";
import BreadCrumb from "components/Common/BreadCrumb/BreadCrumb";
import { useTranslation } from "react-i18next";

const AutomationScheduleChildTaskHeader = ({ reloadList = () => {} }) => {
  const breadcrumbText = [{ title: "Scheduled Automation Tasks", link: "/admin/automation/taskschedules" }, { title: "Child Tasks" }, ];
  const { t } = useTranslation();

  return (
    <div className="filter-container py-3">
      <div className="row align-items-center">
        <div className="col-md-2 col-lg-6 d-none d-md-block mb-3 mb-md-0">
          <BreadCrumb breadCrumbText={breadcrumbText} top={false} />
        </div>
        <div className="col-md-10 col-lg-6 d-flex justify-content-end gap-1 gap-sm-2">
          {/* ---- show parent tasks ---- */}
            <Link
              to="/admin/automation/taskschedules"
              className="btn btn-outline-primary d-flex align-items-center gap-1"
            >
              <span className="d-block material-symbols-outlined icon-md">
                account_tree
              </span>
              <span className="d-block">{t("Show Parent Tasks")}</span>
            </Link>
            {/* ---- show parent tasks end ---- */}
          
          <Link
            onClick={reloadList}
            to="#"
            className="btn btn-gray d-flex align-items-center"
          >
            <span className="d-block material-symbols-outlined icon-md">
              refresh
            </span>
          </Link>

          <button
            type="button"
            className="btn btn-gray d-flex align-items-center gap-1"
            data-bs-toggle="offcanvas"
            data-bs-target="#automationChildTaskFilter"
            aria-controls="automationChildTaskFilter"
          >
            <span className="d-block material-symbols-outlined icon-md">
              filter_list
            </span>
            <span className="d-none d-sm-block">{t("Filter")}</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AutomationScheduleChildTaskHeader;
